import { isAustralianApiUrl } from "@journeys/utils/helpers";

export const AU_SUPPORT_EMAIL = "supportau@spectrum.life";
export const DEFAULT_SUPPORT_EMAIL = "support@spectrum.life";

export const getSupportEmail = (apiUrl: string = process.env.VUE_APP_API_PATH): string =>
  isAustralianApiUrl(apiUrl) ? AU_SUPPORT_EMAIL : DEFAULT_SUPPORT_EMAIL;

export const withSupportEmail = (text: string, apiUrl: string = process.env.VUE_APP_API_PATH): string =>
  text.split(DEFAULT_SUPPORT_EMAIL).join(getSupportEmail(apiUrl));
